import { render, staticRenderFns } from "./ResultsPhase.vue?vue&type=template&id=8aa6c958&"
import script from "./ResultsPhase.vue?vue&type=script&lang=js&"
export * from "./ResultsPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports